import { Box } from "@mui/material";
import { useRecoilValue } from "recoil";
import { assetCompareMoMState } from "@states/asset";
import { ComparedTimeChart } from '@components/chart/ComparedTimeChart';

export default function ChartMoM() {
  const chartData = useRecoilValue(assetCompareMoMState);

  if (!chartData) {
    return <></>;
  }
  return (
    <Box sx={{ mb:7 }}>
      <ComparedTimeChart
        chartValue={chartData}
      />
    </Box>
  );
}
